import { styled } from 'styled-components';

export const PageHeader = styled.div`
  display: flex;
  flex-direction: row;
`;
